import { HttpClient } from '@euler/lib/request';
import {
  ApdmPlateCouponBatchRedeemInput,
  ApdmPlateCouponBatchRedeemResult,
  ApdmPlateCouponItemsResult,
  CouponRecipientQrInput,
} from '@euler/model/apdm';

export class ApdmCouponService {
  constructor(private readonly api: HttpClient) {}
  async items(
    input: CouponRecipientQrInput,
  ): Promise<ApdmPlateCouponItemsResult> {
    return await this.api
      .post()
      .url('/apdm/coupons/scans')
      .data({
        couponCampaignId: input.couponCampaignId,
        recipientToken: input.recipientToken,
      })
      .future();
  }
  async redeem(
    input: ApdmPlateCouponBatchRedeemInput,
  ): Promise<ApdmPlateCouponBatchRedeemResult> {
    return await this.api
      .post()
      .url('/apdm/coupons/batch-redemptions')
      .data({
        couponCampaignId: input.couponCampaignId,
        recipientToken: input.recipientToken,
        requestId: input.requestId,
        lines: input.lines.map(line => ({
          itemId: line.itemId,
          couponIds: line.couponIds,
        })),
      })
      .future();
  }
}
